"use client";

import BatIcon from "@/components/logos/BatIcon";
import { useUser } from "@nitro-ape/shared/features/user/api/get-user";
import { usePingForAccess } from "@nitro-ape/shared/features/user/api/ping-for-access";
import { useLogout } from "@/hooks/use-logout";
import {
  brandConfig,
  BrandMessageIds,
  buildBrandTitle,
} from "@nitro-ape/shared/lib/brand-config";
import { getEnv } from "@/lib/env";
import { translateBrand } from "@/lib/i18n";
import { Trans } from "@lingui/react";
import { FaPowerOff } from "@react-icons/all-files/fa/FaPowerOff";
import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/no-access/")({
  head: () => ({
    meta: [{ title: buildBrandTitle(getEnv, "No Access") }],
  }),
  component: NoAccessPage,
});

function NoAccessPage() {
  const { data: user, isLoading } = useUser();
  const { logout } = useLogout();
  const pingForAccess = usePingForAccess();

  if (user && user.has_access && !isLoading) {
    return <Navigate to="/explore" />;
  }

  const handleOnClick = () => {
    pingForAccess.mutate();
  };

  return (
    <div className="relative flex min-h-screen w-screen items-center justify-center bg-[#0B0B11]">
      <img
        alt="bg-visual"
        src={brandConfig(getEnv).loginBackgroundImagePath}
        className="absolute inset-0 z-0 hidden h-full w-full object-cover object-left md:block"
      />
      <div className="bg-card z-10 mx-3 flex w-full max-w-[530px] flex-col items-center rounded-[25px] px-5 pb-[52px] pt-[44px]">
        <div className="bg-dark-green mb-3 flex h-[60px] w-[60px] items-center justify-center rounded-full p-3 md:h-[72px] md:w-[72px]">
          <BatIcon />
        </div>
        <p className="mb-4 text-3xl">
          <Trans
            id="noAccess.title"
            message="Not whitelisted"
            comment="Heading shown when the user lacks access."
          />
        </p>
        <button
          type="button"
          // to="https://telegram.me/Akio_ichi"
          // target="_blank"
          // rel="noopener noreferrer"
          disabled={pingForAccess.isPending}
          className="bg-dark-green text-green mb-5 flex h-[56px] w-[200px] items-center justify-center rounded-[12px] disabled:opacity-50"
          onClick={handleOnClick}
        >
          <Trans
            id="noAccess.pingButton"
            message="Click to ping devs"
            comment="Button label to notify the team for access."
          />
        </button>
        <p className="text-gray-p text-base">
          {translateBrand(BrandMessageIds.waitlistMessage)}
        </p>

        <button
          type="button"
          onClick={logout}
          className="bg-dark-red text-red mt-5 flex items-center justify-center gap-1 rounded-xl p-2.5 pr-3 text-sm leading-none hover:opacity-80"
        >
          <FaPowerOff />
          <Trans
            id="noAccess.logout"
            message="Log Out"
            comment="Button label to sign out from the no-access page."
          />
        </button>
      </div>
    </div>
  );
}
